import { Table, TableBody, TableCell, TableRow } from '@carbon/react';

const BreakdownSectionValues = ({ values }) => (
  <Table size="sm">
    <TableBody>
      {values.map(([title, value]) => (
        <TableRow key={title}>
          <TableCell style={{ width: '52%' }}>
            <strong>{title}</strong>
          </TableCell>
          <TableCell>{value}</TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
);

export default BreakdownSectionValues;
